import { getCookie } from "./cookieHelpers";
import { guestApi } from "../services/guest";

export const initializeGuestSession = async (store) => {
  // Check for existing cookie first
  const existing = getCookie("guest_session_token");
  if (existing) return existing;

  try {
    // Use RTK Query's imperative API to call the endpoint
    const result = await store.dispatch(
      guestApi.endpoints.getGuestSession.initiate()
    );

    if (result.error) {
      throw new Error(
        result.error.data?.message || "Network error during guest session creation"
      );
    }

    const token = result.data?.guest_session_token;

    if (!token) {
      throw new Error("Guest session creation failed - missing token");
    }

    // Cookie is set automatically in transformResponse
    return token;
  } catch (error) {
    console.error("Failed to init guest session:", error);
    throw error;
  }
};
